/* tslint:disable */
/* eslint-disable */
/**
 * Sprava aktov EU API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AktEuDetail
 */
export interface AktEuDetail {
    /**
     * 
     * @type {string}
     * @memberof AktEuDetail
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof AktEuDetail
     */
    'aktId': string;
    /**
     * 
     * @type {string}
     * @memberof AktEuDetail
     */
    'medziinstitucionalnyKod'?: string;
    /**
     * 
     * @type {string}
     * @memberof AktEuDetail
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AktEuDetail
     */
    'datumPrijatiaAktu'?: string;
    /**
     * 
     * @type {CiselnikPolozka}
     * @memberof AktEuDetail
     */
    'institucia'?: CiselnikPolozka;
    /**
     * 
     * @type {CiselnikPolozka}
     * @memberof AktEuDetail
     */
    'typ'?: CiselnikPolozka;
    /**
     * 
     * @type {CiselnikPolozka}
     * @memberof AktEuDetail
     */
    'stupenUtajenia'?: CiselnikPolozka;
    /**
     * 
     * @type {LegislativnyMaterial}
     * @memberof AktEuDetail
     */
    'legislativnyMaterial'?: LegislativnyMaterial;
    /**
     * 
     * @type {Array<PrilohaAktEu>}
     * @memberof AktEuDetail
     */
    'prilohaAktEuList'?: Array<PrilohaAktEu>;
}
/**
 * 
 * @export
 * @interface AktEuFilter
 */
export interface AktEuFilter {
    /**
     * 
     * @type {string}
     * @memberof AktEuFilter
     */
    'hladanyVyraz'?: string;
    /**
     * 
     * @type {string}
     * @memberof AktEuFilter
     */
    'nazovAktu'?: string;
    /**
     * 
     * @type {string}
     * @memberof AktEuFilter
     */
    'nazovLegislativnehoMaterialu'?: string;
    /**
     * 
     * @type {string}
     * @memberof AktEuFilter
     */
    'cisloLegislativnehoMaterialu'?: string;
    /**
     * 
     * @type {string}
     * @memberof AktEuFilter
     */
    'aktId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AktEuFilter
     */
    'typAktuUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AktEuFilter
     */
    'instituciaUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AktEuFilter
     */
    'medziinstitucionalnyKod'?: string;
    /**
     * 
     * @type {string}
     * @memberof AktEuFilter
     */
    'datumPrijatiaAktuOd'?: string;
    /**
     * 
     * @type {string}
     * @memberof AktEuFilter
     */
    'datumPrijatiaAktuDo'?: string;
}
/**
 * 
 * @export
 * @interface AktEuFilterListItem
 */
export interface AktEuFilterListItem {
    /**
     * 
     * @type {string}
     * @memberof AktEuFilterListItem
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof AktEuFilterListItem
     */
    'aktId': string;
    /**
     * 
     * @type {CiselnikPolozka}
     * @memberof AktEuFilterListItem
     */
    'institucia': CiselnikPolozka;
    /**
     * 
     * @type {string}
     * @memberof AktEuFilterListItem
     */
    'nazovAktu': string;
    /**
     * 
     * @type {string}
     * @memberof AktEuFilterListItem
     */
    'nazovLegislativnehoMaterialu': string;
    /**
     * 
     * @type {string}
     * @memberof AktEuFilterListItem
     */
    'datumPrijatiaAktu': string;
}
/**
 * 
 * @export
 * @interface AktEuFilterListPage
 */
export interface AktEuFilterListPage {
    /**
     * total count of elements
     * @type {number}
     * @memberof AktEuFilterListPage
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof AktEuFilterListPage
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof AktEuFilterListPage
     */
    'size': number;
    /**
     * 
     * @type {Array<AktEuFilterListItem>}
     * @memberof AktEuFilterListPage
     */
    'aktEuList'?: Array<AktEuFilterListItem>;
}
/**
 * 
 * @export
 * @interface CiselnikPolozka
 */
export interface CiselnikPolozka {
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'nazov': string;
    /**
     * 
     * @type {number}
     * @memberof CiselnikPolozka
     */
    'uroven'?: number;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'kod'?: string;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'prefix'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'legislativny'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'platny': boolean;
}
/**
 * 
 * @export
 * @interface LegislativnyMaterial
 */
export interface LegislativnyMaterial {
    /**
     * 
     * @type {string}
     * @memberof LegislativnyMaterial
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof LegislativnyMaterial
     */
    'cisloLegMaterialu': string;
    /**
     * 
     * @type {string}
     * @memberof LegislativnyMaterial
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface Page
 */
export interface Page {
    /**
     * total count of elements
     * @type {number}
     * @memberof Page
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof Page
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof Page
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface PrilohaAktEu
 */
export interface PrilohaAktEu {
    /**
     * 
     * @type {string}
     * @memberof PrilohaAktEu
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof PrilohaAktEu
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof PrilohaAktEu
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrilohaAktEu
     */
    'fileFormat': string;
    /**
     * 
     * @type {CiselnikPolozka}
     * @memberof PrilohaAktEu
     */
    'jazyk'?: CiselnikPolozka;
    /**
     * 
     * @type {string}
     * @memberof PrilohaAktEu
     */
    'datumPublikacie'?: string;
    /**
     * 
     * @type {CiselnikPolozka}
     * @memberof PrilohaAktEu
     */
    'typDokumentuAktEu'?: CiselnikPolozka;
    /**
     * 
     * @type {number}
     * @memberof PrilohaAktEu
     */
    'fileSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrilohaAktEu
     */
    'dmsId': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type SortDirectionEnum = typeof SortDirectionEnum[keyof typeof SortDirectionEnum];



/**
 * AktEuDetailExternalApi - axios parameter creator
 * @export
 */
export const AktEuDetailExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get detail of aktEu.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAktEuDetail: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getAktEuDetail', 'uuid', uuid)
            const localVarPath = `/akty-eu/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AktEuDetailExternalApi - functional programming interface
 * @export
 */
export const AktEuDetailExternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AktEuDetailExternalApiAxiosParamCreator(configuration)
    return {
        /**
         * Get detail of aktEu.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAktEuDetail(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AktEuDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAktEuDetail(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AktEuDetailExternalApi.getAktEuDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AktEuDetailExternalApi - factory interface
 * @export
 */
export const AktEuDetailExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AktEuDetailExternalApiFp(configuration)
    return {
        /**
         * Get detail of aktEu.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAktEuDetail(uuid: string, options?: any): AxiosPromise<AktEuDetail> {
            return localVarFp.getAktEuDetail(uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AktEuDetailExternalApi - object-oriented interface
 * @export
 * @class AktEuDetailExternalApi
 * @extends {BaseAPI}
 */
export class AktEuDetailExternalApi extends BaseAPI {
    /**
     * Get detail of aktEu.
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AktEuDetailExternalApi
     */
    public getAktEuDetail(uuid: string, options?: RawAxiosRequestConfig) {
        return AktEuDetailExternalApiFp(this.configuration).getAktEuDetail(uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AktEuFilterListApi - axios parameter creator
 * @export
 */
export const AktEuFilterListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get filtered Akt EU list.
         * @param {AktEuFilter} aktEuFilter 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAktEuFilteredList: async (aktEuFilter: AktEuFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aktEuFilter' is not null or undefined
            assertParamExists('getAktEuFilteredList', 'aktEuFilter', aktEuFilter)
            const localVarPath = `/akty-eu/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aktEuFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AktEuFilterListApi - functional programming interface
 * @export
 */
export const AktEuFilterListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AktEuFilterListApiAxiosParamCreator(configuration)
    return {
        /**
         * Get filtered Akt EU list.
         * @param {AktEuFilter} aktEuFilter 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAktEuFilteredList(aktEuFilter: AktEuFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AktEuFilterListPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAktEuFilteredList(aktEuFilter, page, size, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AktEuFilterListApi.getAktEuFilteredList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AktEuFilterListApi - factory interface
 * @export
 */
export const AktEuFilterListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AktEuFilterListApiFp(configuration)
    return {
        /**
         * Get filtered Akt EU list.
         * @param {AktEuFilter} aktEuFilter 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAktEuFilteredList(aktEuFilter: AktEuFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: any): AxiosPromise<AktEuFilterListPage> {
            return localVarFp.getAktEuFilteredList(aktEuFilter, page, size, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AktEuFilterListApi - object-oriented interface
 * @export
 * @class AktEuFilterListApi
 * @extends {BaseAPI}
 */
export class AktEuFilterListApi extends BaseAPI {
    /**
     * Get filtered Akt EU list.
     * @param {AktEuFilter} aktEuFilter 
     * @param {number} [page] Page number to return, indexed from one.
     * @param {number} [size] Size of page to return.
     * @param {string} [sortBy] 
     * @param {SortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AktEuFilterListApi
     */
    public getAktEuFilteredList(aktEuFilter: AktEuFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig) {
        return AktEuFilterListApiFp(this.configuration).getAktEuFilteredList(aktEuFilter, page, size, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PrilohaAktEuDownloadExternalApi - axios parameter creator
 * @export
 */
export const PrilohaAktEuDownloadExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} prilohaUuid UUID of AktEuPriloha
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPrilohaAktEu: async (prilohaUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prilohaUuid' is not null or undefined
            assertParamExists('downloadPrilohaAktEu', 'prilohaUuid', prilohaUuid)
            const localVarPath = `/prilohy/{prilohaUuid}/download`
                .replace(`{${"prilohaUuid"}}`, encodeURIComponent(String(prilohaUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrilohaAktEuDownloadExternalApi - functional programming interface
 * @export
 */
export const PrilohaAktEuDownloadExternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrilohaAktEuDownloadExternalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} prilohaUuid UUID of AktEuPriloha
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPrilohaAktEu(prilohaUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPrilohaAktEu(prilohaUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrilohaAktEuDownloadExternalApi.downloadPrilohaAktEu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PrilohaAktEuDownloadExternalApi - factory interface
 * @export
 */
export const PrilohaAktEuDownloadExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrilohaAktEuDownloadExternalApiFp(configuration)
    return {
        /**
         * 
         * @param {string} prilohaUuid UUID of AktEuPriloha
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPrilohaAktEu(prilohaUuid: string, options?: any): AxiosPromise<File> {
            return localVarFp.downloadPrilohaAktEu(prilohaUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrilohaAktEuDownloadExternalApi - object-oriented interface
 * @export
 * @class PrilohaAktEuDownloadExternalApi
 * @extends {BaseAPI}
 */
export class PrilohaAktEuDownloadExternalApi extends BaseAPI {
    /**
     * 
     * @param {string} prilohaUuid UUID of AktEuPriloha
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrilohaAktEuDownloadExternalApi
     */
    public downloadPrilohaAktEu(prilohaUuid: string, options?: RawAxiosRequestConfig) {
        return PrilohaAktEuDownloadExternalApiFp(this.configuration).downloadPrilohaAktEu(prilohaUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



